import React, { useRef }  from "react";
import { connect } from "react-redux";
import Button from "components/button";
import CardItem from "components/card/CardItem";
import { FullDateFormat, NumberFormatter } from "../../../../utils/index";
import { ReactComponent as CompanyLogo } from 'assets/svg/intsamis_logo.svg';
import { useReactToPrint } from 'react-to-print';
import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';

const COETemplate = ({recordData}) => {

	const componentRef = useRef();

    const handlePrint = useReactToPrint({
        content: () => componentRef.current,
    });

	const handleDownloadPdf = async () => {
		if (!componentRef.current) {
			console.error("Component reference is not available");
			return;
		}
	
		const element = componentRef.current;
		const canvas = await html2canvas(element, { scale: window.devicePixelRatio });
		const imgData = canvas.toDataURL("image/png");
		
		const pdf = new jsPDF("p", "mm", "a4");
		const pdfWidth = pdf.internal.pageSize.getWidth();

    	const imgHeight = pdf.internal.pageSize.getHeight();
		const pdfHeight = (canvas.height * pdfWidth) / canvas.width;
	
		if (pdfHeight > imgHeight) {
			let pageHeightLeft = pdfHeight;

			while (pageHeightLeft > 0) {
				pdf.addImage(imgData, "PNG", 0, pageHeightLeft - pdfHeight, pdfWidth, pdfHeight);
				pageHeightLeft -= imgHeight;
				if (pageHeightLeft > 0) {
					pdf.addPage();
				}
			}
		} else {
			pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
		}
	
		pdf.save(`${recordData?.user_details?.udt_last_name}, ${recordData?.user_details?.udt_first_name} - COE.pdf`);
	};
	
	return ( recordData && 
    <>
    	<div ref={componentRef} className="mt-4 grid gap-4">	      	
	      	<CardItem extra={"w-full h-full p-4"}>
		      	<div className="flex justify-between items-end mb-[50px] pb-[20px] border-b-4 border-[#484573]">
			      	<div className="p-5">
			      		<CompanyLogo className="w-[150px] h-auto"/>
			      	</div>
			      	<div className="w-[250px]">
		        		<div className="font-bold text-right">HYVIDONE</div>
						<div className="text-right"></div>
						<div className="text-right">www.hyvidone.com</div>
		        	</div>
		    	</div>

				<div><h2 className="font-bold text-center mt-[20px] mb-[40px]">CERTIFICATE OF CLEARANCE AND EMPLOYMENT</h2></div>

				<div className="mb-2">
					This is to certify that the individual indicated below was an employee of <span className="font-bold">HYVIDONE</span> and that the details that follows are true and correct:
				</div>

				<div className="w-[540px] mx-auto grid grid-cols-2 mt-4 mb-[20px]">
					<div className="font-bold">Employee Name</div><div><span className="mr-[20px]">:</span> {recordData?.user_details?.udt_first_name} {recordData?.user_details?.udt_last_name}</div>
					<div className="font-bold">Position</div><div><span className="mr-[20px]">:</span> {recordData?.emp_title}</div>
					<div className="font-bold">Department</div><div><span className="mr-[20px]">:</span> {recordData?.department?.opt_name}</div>
					<div className="font-bold">Hire Date</div><div><span className="mr-[20px]">:</span> {FullDateFormat(recordData?.emp_hire_date)}</div>
					<div className="font-bold">Separation Date</div><div><span className="mr-[20px]">:</span> {FullDateFormat(recordData?.emp_separation_date)}</div>
					<div className="font-bold">Monthly Basic Salary</div><div><span className="mr-[20px]">:</span> PHP {NumberFormatter(recordData?.salaryDetails?.basic_pay ?? 0)}</div>
					<div className="font-bold">Monthly De Minimis</div><div><span className="mr-[20px]">:</span> PHP {NumberFormatter(recordData?.salaryDetails?.de_minimis ?? 0)}</div>
					<div className="font-bold">Other Monthly Allowances</div><div><span className="mr-[20px]">:</span> PHP {NumberFormatter(recordData?.salaryDetails?.other_allowances ?? 0)}</div>
				</div>

				<div>
					<p className="mb-2">Further, Mr./Ms. {recordData?.user_details?.udt_last_name} has been cleared of all accountabilities from the company.</p>
					<p className="mb-2">For verification, please email Human Resources at hr@hyvidone.com.</p>
					<p className="mb-2">This certification is issued on {FullDateFormat(new Date())}.</p>
					<p className="font-bold mb-2">This certification is electronically generated and does not require a signature.</p>
				</div>

				<div className="mt-[300px] border-t-4 border-[#484573] text-[12px] text-center">
					Delivering Meaningful Experience
				</div>
				        
      		</CardItem>
      	</div>
	      
      	<div className="dark:bg-intsamis-900 text-right mt-3">
  			<Button className="btn-primary" onClick={handleDownloadPdf}>
                Download
            </Button>
		</div>	      
    </>
    );
};

const mapStateToProps = (state) => ({
	recordData: state.employee.employeeCOEDetails?.data,	
});

const mapDispatchToProps = (dispatch) => ({
	
});

export default connect(mapStateToProps, mapDispatchToProps)(COETemplate);